import * as React from 'react';
import { assertNever } from 'owa-assert';
import { getModuleCommand } from 'owa-publishedcalendar-settings';
import { observer } from 'mobx-react-lite';
import PrintDialogRenderer from './PrintDialogRenderer';
import CalendarReadingPanePanel from './CalendarReadingPanePanel';

/**
 * This component ensures that item details and print dialogs are mutually exclusive
 * It fixes a race when new user request comes before previous one is completed.
 */
const ModuleRenderer = observer(function ModuleRenderer() {
    const moduleCommand = getModuleCommand();
    if (!moduleCommand) {
        return null;
    }

    switch (moduleCommand) {
        case 'Open_ItemDetails':
            return <CalendarReadingPanePanel />;
        case 'Open_PrintModal':
            return <PrintDialogRenderer />;
        case null:
            return null;
    }

    return assertNever(moduleCommand);
});
export default ModuleRenderer;
